import { type TypePolicy } from '@apollo/client';

export const Image: TypePolicy = {
    fields: {
        urls: {
            merge: true,
        },
    },
};
